module.exports = __webpack_public_path__ + "static/media/logo_archdiocese_white_150.7d2e5060.webp";